module.exports = __webpack_public_path__ + "static/media/S4N5-4.cc11d939.svg";